import { Instance } from 'mobx-state-tree'
import { PaymentSheetResponseModelBase } from './PaymentSheetResponseModel.base'

/* The TypeScript type of an instance of PaymentSheetResponseModel */
export interface PaymentSheetResponseModelType extends Instance<typeof PaymentSheetResponseModel.Type> {}

/* A graphql query fragment builders for PaymentSheetResponseModel */
export {
  selectFromPaymentSheetResponse,
  paymentSheetResponseModelPrimitives,
  PaymentSheetResponseModelSelector
} from './PaymentSheetResponseModel.base'

/**
 * PaymentSheetResponseModel
 */
export const PaymentSheetResponseModel = PaymentSheetResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
